import { MutationCache, QueryCache, QueryClientConfig, QueryOptions } from '@tanstack/react-query';
import onApiError from 'services/onApiError';
import onApiSuccess from 'services/onApiSuccess';
import type { OneServiceMeta } from 'types/services/services';
import OneBusinessError from 'utils/common/errors/OneBusinessError';
import OneUnauthorizedError from 'utils/common/errors/OneUnauthorizedError';

const onMutationError: MutationCache['config']['onError'] = (error, _variables, _context, mutation) =>
  onApiError(error, mutation.meta as OneServiceMeta | undefined, mutation);

const onMutationSuccess: MutationCache['config']['onSuccess'] = (data, _variables, _context, mutation) =>
  onApiSuccess(data, mutation.meta as OneServiceMeta | undefined);

const onQueryError: QueryCache['config']['onError'] = (error, query) => onApiError(error, query.meta as OneServiceMeta | undefined, query);

const onQuerySuccess: QueryCache['config']['onSuccess'] = (data, query) => onApiSuccess(data, query.meta as OneServiceMeta | undefined);

const defaultRetry: QueryOptions['retry'] = (count, error) => {
  if (error instanceof OneUnauthorizedError || error instanceof OneBusinessError) {
    return false;
  }

  // return count < 4;
  // disable all retries
  return false;
};

const SERVICE_CONFIG = () =>
  ({
    queryCache: new QueryCache({
      onSuccess: onQuerySuccess,
      onError: onQueryError,
    }),
    mutationCache: new MutationCache({
      onSuccess: onMutationSuccess,
      onError: onMutationError,
    }),
    defaultOptions: { queries: { retry: defaultRetry } },
  }) satisfies QueryClientConfig;

export default SERVICE_CONFIG;
